import React, { useEffect, useState } from "react";
import {
  getMisc,
  updateLunaDetails,
} from "../../../apiclients/streamsapi_bridge";
import { MDBAutocomplete } from "mdb-react-ui-kit";
import { useFormContext } from "react-hook-form";
// import RouteOperator from "../editUtils/RouteOperator";
import HumanRouteOperator from "../editUtils/HumanRouteOperator";

function LunaHumanOperator({
  huntOperators,
  scheduleId,
  lunaid,
  setSuccessMessage,
}) {
  const [humanOperators, sethumanOperators] = useState([]);
  const [humanOperatorsDisplay, sethumanOperatorsDisplay] = useState([]);
  const [routingValue, setroutingValue] = useState("");
  const { setValue } = useFormContext();
  const [humanOperatorList, sethumanOperatorList] = useState({});
  const [exUpdate, setExUpdate] = useState(false);
  const [exdetails, setExDetails] = useState({});
  const [externError, setExternError] = useState([]);
  const [calleridFlag, setCalleridFlag] = useState(true);
  const [isLoading, setisLoading] = useState(false);
  const [AddExternalNumber, setAddExternalNumber] = useState(false);
  const [cidPassValue, setcidPassValue] = useState("");

  useEffect(() => {
    getHumanOperatorMisc();
  }, []);

  useEffect(() => {
    if (huntOperators && Object.entries(huntOperators).length > 0) {
      const hopVal = `${huntOperators.title}${
        huntOperators.extension ? " : " + huntOperators.extension : ""
      }${
        huntOperators.hoptype && huntOperators.hoptype === 1
          ? " : Hunt Group"
          : " : User"
      }`;

      setroutingValue(hopVal);
    }
  }, [huntOperators]);

  async function getHumanOperatorMisc() {
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["hopmisc"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    console.log("tdata ::::::::::::::::::::::::::::: " + JSON.stringify(tdata));
    let users = tdata?.misc?.hopmisc?.user ?? [];
    let group = tdata?.misc?.hopmisc?.hg ?? [];
    // let acdgroup = tdata?.misc?.hopmisc?.acd ?? [];
    sethumanOperatorList({
      user: users,
      group: group,
      // acdgroup: acdgroup,
    });
    // const mergeWithSortList = [...users, ...group].sort((a, b) =>
    //   a?.title?.localeCompare(b?.title)
    // );
    // sethumanOperators(mergeWithSortList);
    // sethumanOperatorsDisplay(mergeWithSortList);
  }

  const onAdvancedSearch = (value) => {
    const lowercasedValue = value.toLowerCase();
    if (lowercasedValue.trim() !== "") {
      const filteredData = humanOperators.filter((item) => {
        const lowercasedTitle = item.title.toLowerCase();
        const isTitleMatch = lowercasedTitle.includes(lowercasedValue);
        const isExtensionsMatch =
          item.extensions && item.extensions.toString().includes(value);
        const isCategoryMatch =
          item.category && item.category.toLowerCase().includes(value);
        return isTitleMatch || isExtensionsMatch || isCategoryMatch;
      });

      sethumanOperatorsDisplay(filteredData);
    } else {
      sethumanOperatorsDisplay([]);
    }
  };

  function handleChange(e, result) {
    e.preventDefault();
    console.log("value :::::::::::::: " + JSON.stringify(result));
    const value = {
      hop_type: result.hop,
      val: result.hop === 1 ? result.code : result.id,
    };

    setValue("hop", value, { shouldDirty: true });
  }

  useEffect(() => {
    if (exdetails && exUpdate) {
      console.log("exdetails :::::::::::::: " + JSON.stringify(exdetails));
      if (
        exdetails.cid_pass_flag === true &&
        exdetails.cid_pass &&
        exdetails.cid_pass !== ""
      ) {
        delete exdetails.cid_pass;
      }
      sendApiRequest(exdetails);
      setExUpdate(false);
    }
  }, [exUpdate, exdetails]);

  async function sendApiRequest(exdetails) {
    try {
      const formData = new FormData();
      let luna_permissions = {
        hop: {
          hop_type: 3,
          create_phnum: exdetails,
        },
      };
      formData.append("reqid", 150);
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append("lunaid", lunaid);
      const scheduleType =
        scheduleId === 1
          ? "alltime"
          : scheduleId === 2
          ? "open"
          : scheduleId === 3
          ? "closed"
          : "holiday";
      formData.append("schedule_type", scheduleType);
      formData.append("luna_permissions", JSON.stringify(luna_permissions));
      setisLoading(true);
      for (let [key, value] of formData.entries()) {
        console.log(`form data fields :::::: ${key}: ${value}`);
      }
      let saverep = await updateLunaDetails(formData);
      setisLoading(false);

      let saverepeMsg = await saverep.json();
      console.log("response ::::::::::: " + JSON.stringify(saverepeMsg));
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setValue("hop.hop_type", 3, { shouldDirty: false });
        if (exdetails.name) {
          setValue("hop.name", exdetails.name, { shouldDirty: false });
        }
        if (exdetails.uniqueid) {
          setValue("hop.phnumber", exdetails.uniqueid, { shouldDirty: false });
        }
        if (exdetails.cid_pass_flag !== undefined) {
          setValue("hop.cid_pass_flag", exdetails.cid_pass_flag, {
            shouldDirty: false,
          });
        }
        if (exdetails.cid_pass !== undefined) {
          setValue("hop.cid_pass", exdetails.cid_pass, {
            shouldDirty: false,
          });
        }
        setcidPassValue(exdetails.cid_pass);

        if (saverepeMsg.hopExternalNumber) {
          setValue("hop.val", saverepeMsg.hopExternalNumber, {
            shouldDirty: false,
          });
        }
        setAddExternalNumber(false);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          setExternError(saverepeMsg.message?.errors);
        }
      }
      setExDetails({});
    } catch (error) {
      console.log("error in add external number :::: " + error);
    }
  }

  return (
    <>
      <div className="section-content">
        <div className="general-settings">Human Operator</div>
      </div>
      <div class="add-numbermain">
        <div class="tel-numbers">Human Operator</div>
        <div className="w-30 sm-w-40">
          {/* <MDBAutocomplete
            placeholder="Search User/Group or Extension"
            data={humanOperatorsDisplay}
            id="country"
            value={routingValue}
            onChange={(value) => setroutingValue(value)}
            displayValue={(item) => {
              return `${item.title}${
                item.extensions ? " : " + item.extensions : ""
              }${item.category ? " : " + item.category : ""}`;
            }}
            itemContent={(result) => (
              <div onClick={(e) => handleChange(e, result)}>{`${result.title}${
                result.extensions ? " : " + result.extensions : ""
              }${result.category ? " : " + result.category : ""}`}</div>
            )}
            onSearch={onAdvancedSearch}
          /> */}
          {/* <RouteOperator
            operatorsList={humanOperatorList}
            operatorValue={huntOperators}
            // exUpdate={exUpdate}
            setExUpdate={setExUpdate}
            // exdetails={exdetails}
            setExDetails={setExDetails}
            externError={externError}
            setExternError={setExternError}
            calleridFlag={calleridFlag}
            // setCalleridFlag={setCalleridFlag}
            isLoading={isLoading}
            setisLoading={setisLoading}
            AddExternalNumber={AddExternalNumber}
            setAddExternalNumber={setAddExternalNumber}
            cidPassValue={cidPassValue}
          /> */}
          <HumanRouteOperator
            operatorsList={humanOperatorList}
            operatorValue={huntOperators}
            setExUpdate={setExUpdate}
            setExDetails={setExDetails}
            externError={externError}
            setExternError={setExternError}
            calleridFlag={calleridFlag}
            isLoading={isLoading}
            setisLoading={setisLoading}
            AddExternalNumber={AddExternalNumber}
            setAddExternalNumber={setAddExternalNumber}
            cidPassValue={cidPassValue}
          />
        </div>
      </div>
    </>
  );
}

export default React.memo(LunaHumanOperator);
